<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/xjapppointsdetails/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            :show="false"
        >
            <el-form-item label="用户ID">
                <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="商户号">
                <el-input v-model="formModel.merNo" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="订单号">
                <el-input v-model="formModel.orderNo" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="机具SN号">
                <el-input v-model="formModel.sn" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="账户类型">
                <el-select v-model="formModel.acctType">
                    <el-option
                        v-for="item in acctType"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="交易类型">
                <el-select v-model="formModel.type">
                    <el-option
                        v-for="item in operationType"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="操作类型">
                <el-select v-model="formModel.operationDirection">
                    <el-option
                        v-for="item in operationDirection"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="userId"
                label="用户ID"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="userPhone"
                label="用户手机号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="userName"
                label="用户名称"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="acctType"
                label="账户类型"
                :formatter="formatterTableacctType"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merName"
                label="商户名称"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merNo"
                label="商户号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merPhone"
                label="商户手机号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="orderNo"
                label="订单号"
                min-width="260"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                prop="sn"
                label="SN号"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="type"
                label="交易类型"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="operationDirection"
                label="操作类型"
                min-width="120"
                show-overflow-tooltip
                :formatter="formatterTableoperationDirection"
            ></el-table-column>
            <el-table-column
                prop="number"
                label="变动金额(元)"
                min-width="120"
                show-overflow-tooltip
                :formatter="formatterTableNumber"
            ></el-table-column>
            <el-table-column
                prop="balNumber"
                label="变动后金额(元)"
                min-width="120"
                show-overflow-tooltip
                :formatter="formatterTableNumber"
            >
            </el-table-column>
            <el-table-column
                fixed="right"
                prop="createTime"
                label="创建时间"
                min-width="160"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import TransactionService from "service/TransactionService";
    import LYFAcctTypes from "service/constant/LYFAcctTypes";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "xjapppointsdetails",
        components: {
            CommonTopForm,
            CommonTable,
        },
        data() {
            return {
                acctType: LYFAcctTypes,
                formModel: {
                    acctType: "",
                    userId: "",
                    merNo: "",
                    orderNo: "",
                    sn: "",
                    type: "",
                    time: "",
                    operationDirection: "",
                },
                operationType: [
                    {
                        dictKey: "",
                        dictValue: "全部",
                    },
                ],
                operationDirection: [
                    {
                        dictKey: "",
                        dictValue: "全部",
                    },
                    {
                        dictKey: "1",
                        dictValue: "加",
                    },
                    {
                        dictKey: "2",
                        dictValue: "减",
                    },
                ],
                tableData: [],
                submitService: TransactionService.xjapppointsdetailsList,
                params: {},
                page: {},
                isPage: false,
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.getTypeNames("商户交易类型", (res) => {
                this.operationType = [...this.operationType, ...res];
            });
            this.load();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == "") {
                    this.formModel.time = [];
                }
                const params = {
                    acctType: this.formModel.acctType,
                    userId: this.formModel.userId,
                    merNo: this.formModel.merNo,
                    orderNo: this.formModel.orderNo,
                    sn: this.formModel.sn,
                    type: this.formModel.type,
                    operationDirection: this.formModel.operationDirection,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length) {
                    params.startDate = this.formModel.time[0];
                    params.endDate = this.formModel.time[1];
                }
                return params;
            },
            ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
        },
        methods: {
            load() {
                this.formModel = {
                    type: "",
                    time: "",
                    operationDirection: "",
                };
                this.page = this.$refs.commonTable.page;
                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            formatterTableoperationDirection(row, column, cellValue, index) {
                let value = "--";
                this.operationDirection.forEach((item) => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue;
                    }
                });
                return value;
            },
            // formatterTableoperationType(row, column, cellValue, index) {
            //   let value = "--";
            //   this.operationType.forEach((item) => {
            //     if (item.dictKey == cellValue) {
            //       value = item.dictValue;
            //     }
            //   });
            //   return value;
            // },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/XJAppPointsDetails.vue